import { Box, Stack } from "@mui/material"
import {
    ScheduleOverview,
    ScheduleOverviewExtraContext,
} from "./overwrite/task-correlator/components/schedule-overview"
import { Bound } from "lib/@components/binding/Bound"
import { indexTasksInSchedule } from "routes/schedule/lib/index-tasks-in-schedule"
import { TaskList } from "routes/schedule/schedule-details"
import { ScheduleViewMode } from "routes/schedule/scheduleViewMode"
import { useMemo } from "react"
import { useEnrichedMacroMap } from "authoring/routes/macro/hooks/use-enriched-macro-map"
import { collectMacroTokensFromSchedule } from "authoring/routes/macro/lib/macro-token-utils"
import { MacroExpander } from "authoring/routes/macro/components/macro-expander"

export function ExpandSchedule({ expandedSchedule }) {
    const { version, tasks } = expandedSchedule
    indexTasksInSchedule(expandedSchedule)
    const tokenIds = useMemo(collectTokenIds, [tasks])
    const { macroMap } = useEnrichedMacroMap({ tokenIds })

    ScheduleOverviewExtraContext.usePlug(
        <Box if={(c) => c.targetId === expandedSchedule.id && tasks?.length > 0}>
            <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
                <ScheduleViewMode />
            </Stack>
            <TaskList schedule={expandedSchedule} />
        </Box>
    )

    return (
        <Bound isAuthoring schedule={expandedSchedule} target={expandedSchedule} version={version} macroMap={macroMap}>
            <MacroExpander>
                <Box className="styled-bullets" data-cy="expand-schedule-content">
                    <ScheduleOverview
                        sx={{ "&.Mui-expanded": { boxShadow: 0 } }}
                        cardSx={{ "&.MuiCard-root": { boxShadow: 0 } }}
                        expanded
                        expandIcon={null}
                        showHeader={false}
                    />
                </Box>
            </MacroExpander>
        </Bound>
    )

    function collectTokenIds() {
        if (!tasks?.length) return []
        return [...collectMacroTokensFromSchedule({ tasks })]
    }
}
